import { z } from 'zod';
import { VollWalletRefSchema } from './voll_wallet_pix.js';

/** Um item das listas da alocação: o nome pode vir vazio do cadastro. */
const OptionSchema = z.object({ id: z.string().min(1), name: z.string() }).strict();

/** A alocação que o viajante escolheu: só os ids. O BFF confere que a empresa e o centro de
 *  custo são permitidos a ele e manda ao legado os nomes do servidor. */
export const VollWalletAllocationInputSchema = z
  .object({
    companyId: z.string().min(1),
    costCenterId: z.string().min(1),
    /** The project, when the client uses projects; checked against the company's. */
    projectId: z.string().min(1).optional(),
  })
  .strict();
export type VollWalletAllocationInput = z.infer<typeof VollWalletAllocationInputSchema>;

/**
 * `GET /voll-wallet/allocation` — as empresas que o viajante pode usar na carteira e o padrão
 * do cadastro (`null` = sem padrão). `search`: a lista de centros de custo da empresa não é
 * completa (o cadastro libera todos) e a escolha vem de `GET /voll-wallet/allocation/cost-centers`.
 */
export const VollWalletAllocationFormSchema = z
  .object({
    companies: z.array(
      z
        .object({
          id: z.string().min(1),
          name: z.string(),
          costCenters: z.array(OptionSchema),
          search: z.boolean(),
          /** The company's projects; empty when the client does not use projects. */
          projects: z.array(OptionSchema),
        })
        .strict(),
    ),
    company: VollWalletRefSchema.nullable(),
    costCenter: VollWalletRefSchema.nullable(),
    /** The client asks for a project in the allocation (`enableProjectField`). */
    projectsEnabled: z.boolean(),
  })
  .strict();
export type VollWalletAllocationForm = z.infer<typeof VollWalletAllocationFormSchema>;

/** `GET /voll-wallet/allocation/cost-centers?companyId=&term=` — a busca de centros de custo de
 *  uma empresa permitida ao viajante. */
export const VollWalletCostCentersSchema = z.object({ items: z.array(OptionSchema) }).strict();
export type VollWalletCostCenters = z.infer<typeof VollWalletCostCentersSchema>;
